import React, { PropTypes } from 'react';
import classNames from 'classnames';

const StandardModal = ({
  bodyOverflow,
  visible,
  title,
  wideModal,
  children,
  onCloseClick,
  disableClose
}) => (
  <div
    className={classNames(
      "modal",
      { "display block animated fadeIn": visible }
    )}
    style={{ overflow: 'auto', paddingRight: "0px" }}
  >
    <div className={classNames(
      "modal-dialog",
      { "wide-modal": wideModal })}>
      <div className="modal-content">
        <div className="modal-header">
          <button
            type="button"
            className="close"
            aria-hidden="true"
            onClick={onCloseClick}
            disabled={disableClose == true}
          >&times;</button>
          <h4 className="modal-title">{title}</h4>
        </div>
        <div className={classNames(
          "modal-body",
          { "overflow-y": bodyOverflow }
        )}>
          {children}
        </div>
      </div>
    </div>
  </div>
);

StandardModal.propTypes = {
  bodyOverflow: PropTypes.bool,
  visible: PropTypes.bool,
  title: PropTypes.string,
  wideModal: PropTypes.bool,
  children: PropTypes.node,
  onCloseClick: PropTypes.func,
  disableClose: PropTypes.bool
};

StandardModal.defaultProps = {
  wideModal: false
};

export default StandardModal;



// WEBPACK FOOTER //
// ./src/features/shared/StandardModal.jsx